import React from 'react';
import Hero from '../components/sections/Hero';
import OurStory from '../components/sections/OurStory';
import LegendDishes from '../components/sections/LegendDishes';
import OffersSection from '../components/sections/OffersSection';
import DrinksSection from '../components/sections/DrinksSection';
import ElJefeSection from '../components/sections/ElJefeSection';

const Home: React.FC = () => {
  return (
    <div>
      <Hero />
      <OurStory />
      <LegendDishes />
      <OffersSection />
      <DrinksSection />
      <ElJefeSection />
    </div>
  );
};

export default Home;
